import React, { useState } from "react";
import { Input } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { allapiAction } from "../../Redux/common/action";
import { Button } from "antd";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [partnerData, setpartnerData] = useState({ phone: "", password: "" });

  const hendleTochange = (e) => {
    const { name, value } = e?.target;
    setpartnerData({ ...partnerData, [name]: value });
  };

  const hendleToSubmit = (e) => {
    e.preventDefault();
    if (!partnerData?.phone) {
      toast.error("please enter phone number");
    } else if (!partnerData?.password) {
      toast.error("please enter password");
    } else {
      dispatch(allapiAction.signinDeliveryPartner(partnerData, navigate));
      return () => {};
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="logo-title">
          <h3>Delivery Partner</h3>
          <p>Log In Your Account</p>
        </div>
        <form onSubmit={hendleToSubmit}>
          <div className="form-group">
            <label>Phone Number</label>
            <Input
              type="text"
              className="form-control"
              placeholder="Enter phone number"
              name="phone"
              value={partnerData?.phone}
              onChange={hendleTochange}
              autoComplete="new-off"
            />
          </div>
          <div className="form-group mt-10">
            <label>Password</label>
            <Input
              type="password"
              className="form-control"
              placeholder="Enter password"
              name="password"
              value={partnerData?.password}
              onChange={hendleTochange}
              autoComplete="new-off"
            />
          </div>
          <Button
            type="primary"
            block
            className="mt-10"
            htmlType="submit"
            style={{ height: 40, fontSize: 15 }}
          >
            Sign In
          </Button>
        </form>
      </div>
    </div>
  );
}

export default Login;